import React, { ReactNode } from "react";

import "./HotelOffsetTable.css";

export interface HotelOffsetTableColumn {
  id: string;
  header: string;
  accessor: (row: any) => ReactNode;
  width?: string | number;
}

export interface HotelOffsetTableRow {
  id: string;
  number: number;
  selected: boolean;
}

type Props<T extends HotelOffsetTableRow> = {
  columns: HotelOffsetTableColumn[];
  data: Array<T>;
  onRowSelected: (row: T) => void;
  style?: React.CSSProperties;
};

export default function HotelOffsetTable<T extends HotelOffsetTableRow>({
  columns,
  data,
  onRowSelected,
  style,
}: Props<T>) {
  const getTableHeader = (columns: HotelOffsetTableColumn[]) => {
    return (
      <tr>
        {columns.map((column: HotelOffsetTableColumn) => {
          return (
            <th key={column.header} style={{ width: column.width }}>
              {column.header}
            </th>
          );
        })}
      </tr>
    );
  };

  const getTableRows = (data: Array<T>, columns: HotelOffsetTableColumn[]) => {
    return data.map((row: T, rowIdx: number) => (
      <tr
        key={row.id}
        onClick={() => onRowSelected(row)}
        className={row.selected ? "selected" : ""}
      >
        {columns.map((column, colIdx) => (
          <td key={`${row.id}_${column.id}`} style={{ width: column.width }}>
            {column.accessor(row)}
          </td>
        ))}
      </tr>
    ));
  };

  return (
    <div className="table-container" style={{ ...style }}>
      <table className="hotel-calibration-table">
        <thead>{getTableHeader(columns)}</thead>
        <tbody>{getTableRows(data, columns)}</tbody>
      </table>
    </div>
  );
}
